import React from 'react'
import { useNavigate } from 'react-router-dom';

import imageOne from '../../resource/talks/ourteacher/2.png'
import imageThree from '../../resource/talks/ourteacher/1[1].png'
import imageTwo from '../../resource/talks/ourteacher/6.png'
import imageSeven from '../../resource/talks/ourteacher/7.png'

import imageFour from '../../resource/talks/ourteacher/4.png'
import TitleChnage from '../../Hook/TitleChnage'
import imageFive from '../../resource/talks/ourteacher/5.png'

const DammaTalksOurTeahcer = () => {

    TitleChnage("Our Teahcer")
    
        const navigate = useNavigate();
    const handleClick = (event) => {

        const pathMap = {
            dammaTalksPage: '/dammaTalksPage',
        }

        const path = event.currentTarget.id;
        const targetPath = pathMap[path]

        if (targetPath) {
            navigate(targetPath)
        }
    }
    return (
        <div className="dmmatalkteahcer-page inside-pages">
            <div className="right-box">
                <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
            </div>

            <h1 className='font-main  p-4 mt-4'>Our Teahcer</h1>

            <div className="poem-1 mt-6 h4-bold">
                <div>
                    <p >Let’s find time – and quiet place </p>
                    <p >Mindful and calm - with lot of faith </p>
                    <p >Will pay the respect – To triple Gem</p>
                    <p >Sit on cushion – Ready to listen</p>

                    <p className=" mt-5">Sutta, Vinaya – Pali with meaning </p>
                    <p >Words and chants – Heart is bright   </p>
                    <p >Gentle in thoughts – Words and deeds </p>
                    <p >Living Dhamma - Embrace with smile  </p>

                    <p className=" mt-5">A timely call – come and listen </p>
                    <p >Keep faith alive  - tune in every word </p>
                    <p >Rhythm of life – Gentle livelihood  </p>
                    <p >Bright as sun – Light of wisdom</p>
                </div>
            </div>



            <h1 className='font-second text-black p-4 mt-6 text-center'>Damma Talks</h1>

            <p className="h4-bold mt-5 p-4 text-center">We can listen to both previous and new Dhamma talks by the Most Venerable Wegodapola Wimalagnana Maha Thero through the following links.</p>

          

                <div className="btn-group2 mt-6">
      <img src={imageFour} alt="Right Top Image" width={300} onClick={handleClick}  className="curser-pointer" id='dammaTalksPage'/>
      <img src={imageFive} alt="Right Top Image" width={300}  className="curser-pointer" id='internalRetreatForm'/>
    </div>

    <div className="btn-group2 mt-5">
      <img src={imageSeven} alt="Right Top Image" width={300}  className="curser-pointer" id='internalRules'/>
      <img src={imageTwo} alt="Right Top Image" width={300}  className="curser-pointer" id='internalRetreatForm'/>
    </div>
            <div className="bottom-box mt-6">
                <img src={imageThree} alt="bottom-image" width={600} />
            </div>
        </div>
    )
}

export default DammaTalksOurTeahcer
